export interface Config {
  /** Config for back-end connection. */
  api: {
    /** URL of SignalR hub. */
    url: string
    /** Delay (ms) before trying to reconnect when connection is lost */
    reconnectDelay: number
    /** Timeout (ms) for token refresh before it expires */
    refreshTokenTimeout: number
    /** Timeout (ms) for websocket before page reload */
    serverTimeoutInMilliseconds: number
  }
  keycloak: {
    realm: string
    domain: string
    client: string
    redirectUri: string
  }
  env: string
  sentry: Record<string, object>
}

type DefaultConfig = { default: Config }

const nodeEnv = import.meta.env.MODE

/*
  Local modes dynamically import config/local.ts; deployed builds
  read window.config. Use .env.[mode] for VITE_XXX overrides.
 */

async function loadConfig(): Promise<Config> {
  if (['test', 'localdev', 'proxy'].includes(nodeEnv)) {
    const allConfig = (await import(
      '../config/local'
    )) as unknown as DefaultConfig
    const baseConfig = allConfig.default
    return {
      api: {
        ...baseConfig.api,
        url: import.meta.env.VITE_API_URL || baseConfig.api.url
      },
      keycloak: {
        ...baseConfig.keycloak
      },
      env: baseConfig.env,
      sentry: baseConfig.sentry || {}
    }
  } else {
    const baseConfig = (window as any).config
    return {
      ...baseConfig,
      env: baseConfig.env,
      sentry: baseConfig.sentry || {}
    }
  }
}

const config = await loadConfig()

export default config
